
import "../../css/winpeCollegiumView.css";
import "animate.css/animate.min.css";
import ScrollAnimation from "react-animate-on-scroll";
import React, { Component } from "react";
import "../../css/toastView.css";
import Heading from "../../components/Heading";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";
import "../../components/new.css";


const icon1 = "https://winpeforum.com/assets/ambassadors/Ishita_Suri_amb.jpg";
const icon2 = "https://winpeforum.com/assets/ambassadors/Pooja_Parmar_amb.jpg";
const icon3 = "https://winpeforum.com/assets/ambassadors/Pooja_Sharoff_amb.jpg";
const icon4 = "https://winpeforum.com/assets/ambassadors/Shikha_Pareek_amb.jpg";
const icon5 = "https://winpeforum.com/assets/elements/Shriya.jpeg";
const icon6 = "https://winpeforum.com/assets/elements/vidhi.jpg";
const icon7 = "https://winpeforum.com/assets/elements/AravindKrishnan.png";
const icon8 = "https://winpeforum.com/assets/elements/SandeepNaik.png";
const icon9 = "https://winpeforum.com/assets/elements/SatishChander.png";

let duration = 400;

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

class WiI extends Component {
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
    
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;

    return (
      <ContentPage>
        <Meta
          title="Winpe | Privacy Policy"
          description=" 
          "
          image={
            "https://winpeforum.com/api/src/templates/emailers/assets/newsletter2022.png"
          }
          location={location}
        />
        <div className="section__content" style={defaultStyle}>
          <div className="winpecollegium_wrapper">
            
            <div className="winpecollegium_section">
              <div className="winpecollegium_content">
                <div className="winpecollegium_mid_section">
                  <div className="mid_winpecollegium_heading">
                    <br /><br /> <div className="m_heading">Winpe Privacy Policy</div>
                    <div className="r_btm"></div>
                   
                  </div>
                  <ScrollAnimation
                    delay={0}
                    duration={3}
                    animateIn="slideInRight"
                    offset={300}
                  >
                    <div className="winpecollegium_top_text" style={{ textAlign: "justify" }}>
      
 

  
          
<i>Last updated: 17/09/2026</i><br/><br/>
Winpe Development Private Limited and Winpe Development Forum (“Winpe”, “we”, “our”, or “us”) are
committed to protecting your privacy and handling your personal data responsibly and transparently.
This Privacy Policy explains how we collect, use, process, store, share, transfer, and protect personal
data.<br/><br/>
This Privacy Policy is intended to comply with the provisions of the Digital Personal Data Protection Act,
2023 (&quot;DPDP Act&quot;), the Digital Personal Data Protection Rules, 2025, and any amendments thereto.
By accessing our website, registering for our programmes, participating in our initiatives, subscribing to
our communications, or otherwise engaging with Winpe, you acknowledge that you have read and
understood this Privacy Policy.

<br/><br/>
<h4><b>1. Scope of This Policy</b></h4>
<p>This Privacy Policy applies to personal data collected through:</p>
<ul>
    <li>The Winpe website</li>
    <li>Event and webinar registration forms</li>
    <li>Newsletter subscriptions</li>
    <li>Surveys, research initiatives, and program participation</li>
    <li>Email communications and other digital interactions with Winpe</li>
</ul>
<p>This Policy does not apply to third-party websites, platforms, or services that may be linked through our website.</p>

<h4><b>2. Personal Data We Collect</b></h4>
<p>We may collect and process the following categories of personal data:</p>
<ul>
    <li>Full name</li>
    <li>Email address</li>
    <li>Phone number</li>
    <li>Organisation name</li>
    <li>Job title/designation</li>
    <li>Event or webinar registration details</li>
    <li>Information submitted through forms, surveys, or applications</li>
    <li>Queries, feedback, or communication shared with us</li>
    <li>Any other information voluntarily provided by you</li>
</ul>

<p>When you visit our website, certain technical information may be collected automatically, including IP address, browser type, device information, pages visited, and interaction data.</p>

<p>If you participate in Winpe events or webinars hosted through third-party platforms, those platforms may independently collect certain information subject to their own privacy policies.</p>

<p>Individuals are responsible for ensuring that the personal data they provide to Winpe is accurate and kept reasonably up to date.</p>

<h4><b>3. Purpose of Processing Personal Data</b></h4>
<p>We process personal data only for legitimate and communicated purposes, including:</p>
<ul>
    <li>Managing event registrations, webinars, programs, consultations and initiatives</li>
    <li>Sending updates, reminders, newsletters, and knowledge resources</li>
    <li>Responding to inquiries and feedback</li>
    <li>Conducting analytics and improving website functionality and user experience</li>
    <li>Maintaining participant records and generating internal reports</li>
    <li>Ensuring security and preventing misuse of our digital platforms</li>
</ul>

<p>Participation in Winpe events, webinars, interviews, recordings, photographs, videos, and knowledge-sharing initiatives may result in the creation and publication of content on Winpe's websites, reports, newsletters, social media channels, and other communication platforms.</p>

<h4><b>4. Legal Basis and Consent</b></h4>
<p>By voluntarily providing your personal data through our website, forms, registrations, or communications, you consent to its processing for the purposes described in this Privacy Policy.</p>

<p>Consent may be withdrawn at any time by contacting: <a href="mailto:info@winpeforum.com">info@winpeforum.com</a></p>

<p>Withdrawal of consent will not affect the lawfulness of processing carried out before such withdrawal.</p>

<h4><b>5. Website Usage and Analytics</b></h4>
<p>At present, Winpe’s website does not intentionally use cookies for tracking or advertising purposes.</p>

<p>Limited technical or analytics-related information may still be collected through standard website hosting, security tools, or third-party integrations to ensure proper website functionality and performance.</p>

<p>If Winpe introduces cookies or similar tracking technologies in the future, this Privacy Policy will be updated accordingly.</p>

<h4><b>6. Sharing of Personal Data</b></h4>
<p>We may share personal data with trusted third parties where necessary, including:</p>
<ul>
    <li>Event hosting and communication platforms</li>
    <li>Technology and website support vendors</li>
    <li>Research, survey, or analytics service providers</li>
    <li>Partner organisations or collaborators for jointly hosted initiatives</li>
</ul>

<p>We do not sell, rent, or trade personal data to third parties.</p>

<p>Some of these service providers may process or store personal data on servers located outside India, subject to applicable legal and contractual safeguards.</p>

<h4><b>7. Data Retention</b></h4>
<p>We retain personal data only for as long as necessary to fulfil the purposes for which it was collected, including operational, legal, administrative, archival, research, and knowledge dissemination purposes.</p>

<p>The duration of retention may vary depending on the nature of engagement, legal obligations, organisational requirements, and archival purposes.</p>

<p>Event recordings, knowledge sessions, interviews, photographs, videos, and educational content published on Winpe’s official platforms may continue to be retained as part of ongoing institutional and archival activities.</p>

<p>Where personal data is no longer required for the purposes for which it was collected, and where retention is not otherwise required by law or legitimate organisational needs, Winpe will securely delete, anonymise, or archive such information in accordance with applicable law.</p>

<h4><b>8. Your Rights</b></h4>
<p>Subject to applicable law, you may:</p>
<ul>
    <li>Request access to your personal data</li>
    <li>Request correction, completion, updating, or erasure of personal data</li>
    <li>Withdraw consent where processing is based on consent</li>
    <li>Raise grievances regarding processing of your personal data</li>
    <li>Nominate another individual to exercise your rights in accordance with applicable law</li>
</ul>

<p>Requests may be submitted to: <a style={{color:'blue', textDecoration:'underline'}} href="mailto:info@winpeforum.com">info@winpeforum.com</a></p>

<h4><b>9. Data Security</b></h4>
<p>We implement reasonable technical, administrative, and organisational safeguards to protect personal data against unauthorised access, disclosure, misuse, alteration, or loss.</p>

<p>These safeguards may include restricted access controls, secure storage systems, vendor assessments, and internal confidentiality practices.</p>

<h4><b>10. Children's Privacy</b></h4>
<p>Winpe's services are intended for individuals aged 18 years and above. We do not knowingly collect personal data from children.</p>

<h4><b>11. Third-Party Links</b></h4>
<p>Our website may contain links to external websites or third-party platforms. Winpe is not responsible for the privacy practices or content of such external websites.</p>

<h4><b>12. Grievance Officer</b></h4>
<p>For questions, concerns, or complaints regarding this Privacy Policy or personal data processing, please contact:</p>

 <b>Tasneem Vakil</b> <br/>
     Email: <a style={{color:'blue', textDecoration:'underline'}}  href="mailto:info@winpeforum.com">info@winpeforum.com</a> <br/>
     Response Timeline: Within 7 working days <br/><br/>

<p>Data Principals may contact the Grievance Officer regarding the exercise of their rights under applicable data protection laws.</p>

<h4><b>13. Changes to This Privacy Policy</b></h4>
<p>We may update this Privacy Policy periodically to reflect operational, legal, or regulatory changes.</p>

<p>The updated version will be posted on this page along with the revised "Last Updated" date.</p>

<h4><b>14. Contact Us</b></h4>
<p>For any questions regarding this Privacy Policy or Winpe’s data practices, please contact:</p>

 <b>Winpe</b><br/>
 Email: <a style={{color:'blue', textDecoration:'underline'}}  href="mailto:info@winpeforum.com">info@winpeforum.com</a>
 

                     
                   <br/><br/>   <br/><br/>  
 
                    </div>
                  </ScrollAnimation>

                </div>
              </div>
            </div>
            <TeamModal
              show={isShow}
              onHide={this.togglePopUp}
              activeItem={this.state.activeItem}
            />
          </div>
        </div>
      </ContentPage>
    );
  }
}

WiI.propTypes = {
  location: PropTypes.object,
};

export default WiI;



// WEBPACK FOOTER //
// ./src/pages/PrivacyPolicy/index.js